import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs, urlParams } from '@ctct/infrastructure-layer';

const isStripePhase2EnabledViaURLParam = urlParams.getIfStripePhase2TurnedOn();

export const useIsStripePhase2Enabled = () => {
  if (envs.isSecure()) {
    return {
      data: isStripePhase2EnabledViaURLParam,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'stripe_phase_2',
    defaultValue: isStripePhase2EnabledViaURLParam,
  });
};
